<template>
    <div :style="'background: whitesmoke;'">
        <div class="main-container">
            <div >
                <div class="d-flex pt-2">
                    <div class="cursor-pointer" @mouseover="isHovered = true" @mouseleave="isHovered = false">
                        <div class="icon_hover">
                            <q-img @click="$router.go(-1)" :src="'/arrow.png'" @mouseover="isHovered = true"
                                @mouseleave="isHovered = false" :style="'width:25px; height: 25px'" />
                        </div>
                    </div>
                    <div :style="'padding-top: 3px;'">
                        <span class="ml-3 text-bold" :style="'font-size: 22px;'">Confirm Your details</span>
                    </div>
                </div>
            </div>

            <div v-if="cartProducts.length > 0" class="row mt-1 justify-center d-flex">
                <!-- <div class="col-2">
                </div> -->
                <div class="col-8">
                    <q-card class="p-2">
                        <h6 class="pl-4 font-family font-text-size text-grey-7">Confirm Your Email</h6>
                        <div class="d-flex justify-content-between mt-3 pl-4">
                            <div class="text-bold font-family" :style="'font-size: 15px'">
                                {{ user?.organization?.email }}
                            </div>
                            <div class="mr-4">
                                <div @click="editEmail" class="font-family text-price-value cursor-pointer"
                                    :style="'font-size: 16px; text-decoration: underline;'">
                                    Edit Email ID
                                </div>
                            </div>
                        </div>
                        <div v-if="organizationEmailStatus == false && isLoading" class="d-flex">
                            <div class="mt-4 ml-4 text-red font-family" :style="'font-size: 16px;'">
                                Your Email is not Verified
                            </div>
                            <div @click="verifyEmail" class="mt-4 ml-5 font-family text-price-value cursor-pointer"
                                :style="'font-size: 16px; text-decoration: underline;'">
                                Verify Your Email
                            </div>
                        </div>
                        <div v-if="organizationEmailStatus" class="d-flex ml-4">
                            <q-img class="mt-4" :src="'/verified.png'" :style="'width:25px; height: 25px'" />
                            <div class="mt-4 ml-4 font-family" :style="'font-size: 16px; color: #00AA6F'">
                                Your Email is Verified
                            </div>
                        </div>
                        <div class="ml-4 mt-4">
                            <span class="text-grey-7 font-family text-bold">Note</span>
                        </div>
                        <div class="ml-4">
                            <span class="text-grey-7 font-family">You will receive License Key on this email ID only</span>
                        </div>
                        <q-separator class="my-4">
                        </q-separator>
                        <div class="d-flex justify-content-between mt-2">
                            <h6 class="pl-4 font-family font-text-size text-grey-7">Confirm Your Address</h6>
                            <div @click="UpdateAddressData" class="mr-4 text-price-value font-family cursor-pointer"
                                :style="'font-size: 16px; text-decoration: underline;'">
                                Edit Address
                            </div>
                        </div>
                        <div v-if="user.organization.address" class="ml-4 mt-2 text-bold font-family">
                            <div v-if="user.organization.address.add1" class="mb-1">
                                {{ user.organization.address.add1 }},
                            </div>
                            <div v-if="user.organization.address.add2">
                                {{ user.organization.address.add2 }},
                            </div>
                            <div v-if="user.organization.address.area">
                                {{ user.organization.address.area }},
                            </div>
                            <div v-if="user.organization.address.pin">
                                {{ user?.organization?.address?.city }} - {{ user?.organization?.address?.pin }} ,
                                {{ user?.organization?.address?.state }} , {{ user?.organization?.address?.country }}
                            </div>
                        </div>
                        <div class="ml-4 mt-4">
                            <span class="text-grey-7 font-family text-bold">Note</span>
                        </div>
                        <div class="ml-4 mb-5">
                            <span class="text-grey-7 font-family">This Address will be used as your Billing Address of invoice
                                for this
                                order</span>
                        </div>
                    </q-card>
                </div>
                

                <div class="col-3 px-2">
                    <q-card class="mb-3 order-summary-grid">
                        <div class="text-center p-3" :style="'background: #044b9a1a'">
                            <span class="text-bold font-family mt-2"  :style="'font-size:22px; color: #044B9A'">Order Summary</span>
                        </div>
                        <q-card-section :style="'background: #044b9a1a'">
                            <div>
                                <div class="">
                                    <div class="d-flex mt-2  justify-between mx-2">
                                        <h6 class="font-family font-text-size">Order Total</h6>
                                        <h6 class="font-text-size" :style="'color: #167E85; font-size:18px'"> {{ (payableTotal + savingTotal) |
                                            currencyFilter }}</h6>
                                    </div>
                                    <q-separator class="my-2" />
                                    <div class="d-flex mt-2 justify-between mx-2">
                                        <h6 class="font-family font-text-size">Your Savings <span class="font-text-size text-bold"
                                                :style="'color: #388E3C;'">({{ savingPercentage }}%)</span>
                                        </h6>
                                        <h6 class="font-text-size" :style="'color: #388E3C;'">{{ savingTotal | currencyFilter }}</h6>
                                    </div>
                                    <q-separator class="my-2" />
                                    <div class="d-flex mt-2 justify-between mx-2">
                                        <h6 class="font-family font-text-size">Order Amount</h6>
                                        <h6 class="font-text-size" :style="'color: #167E85; font-size:18px'">{{
                                            payableTotal |
                                            currencyFilter }}</h6>
                                    </div>
                                    <q-separator class="my-2" />
                                    <div v-if="gstColumn" class="d-flex mt-2 justify-between mx-2">
                                        <h6 class="font-family font-text-size">SGST Amount <span class="font-text-size">(9%)</span></h6>
                                        <h6 class="font-text-size" :style="'color: #167E85; font-size:18px'">{{ gstCount('sgst') |
                                        currencyFilter }}</h6>
                                    </div>
                                    <div v-if="gstColumn" class="d-flex mt-2 justify-between mx-2">
                                        <h6 class="font-family font-text-size">CGST Amount <span class="font-text-size">(9%)</span></h6>
                                        <h6 class="font-text-size" :style="'color: #167E85; font-size:18px'">{{ gstCount('cgst') |
                                        currencyFilter }}</h6>
                                    </div>
                                    <div v-if="!gstColumn" class="d-flex mt-2 justify-between mx-2">
                                        <h6 class="font-family font-text-size">IGST Amount <span class="font-text-size">(18%)</span></h6>
                                        <h6 class="font-text-size" :style="'color: #167E85; font-size:18px'">{{ gstCount('igst') |
                                        currencyFilter }}</h6>
                                    </div>
                                    <q-separator class="my-2" />
                                    <div class="d-flex mt-2 justify-between mx-2">
                                        <h6 class="text-black font-text-size">Total Amount</h6>
                                        <h6 class="font-text-size" :style="'color: #167E85; font-size:18px'">{{ payableTotalAmount() |
                                        currencyFilter }}</h6>
                                    </div>
                                    <div class="d-flex mt-2 justify-between mx-2">
                                        <h6 class="text-black font-text-size">Rounded Amount</h6>
                                        <h6 class="font-text-size" :style="'color: #167E85; font-size:18px'">{{ sign() }} {{ roundedAmount() |
                                        currencyFilter }}</h6>
                                    </div>
                                    <q-separator class="my-2" />
                                    <div class="d-flex mt-2 justify-between mx-2">
                                        <h6 class="text-black text-bold font-text-size">Payable Amount</h6>
                                        <h6 class="font-text-size" :style="'-webkit-text-stroke-width: medium; color: #167E85; font-size:18px'">{{
                                            payableAmount() |
                                            currencyFilter }}</h6>
                                    </div>
                                    <q-separator class="my-2" />
                                    <div class="mx-4 mt-4 my-5 text-center">
                                        <span class="font-family text-bold text-grey" style="font-size: 13px">
                                            *Click on Pay Now to complete the payment process and confirm your order.
                                        </span>
                                    </div>
                                    <!-- <q-separator class="my-2" /> -->
                                    <div class=" mt-3 text-center mx-2">
                                        <q-btn no-caps @click="payNow()" class="mt-3 view-cart"
                                            :style="'background-color: #105992'">
                                            <q-img :src="'/whiteBag.png'"
                                                :style="'width:20px; height: 20px;'" />
                                            <span class="ml-4 text-white text-bold" :style="'font-size: 18px; letter-spacing: 1px;'">
                                                Pay Now
                                            </span>
                                        </q-btn>
                                    </div>
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                    <q-dialog persistent position="right" v-model="addPartnerDialog">
                        <UpdateAddress @closeUpdateAddressDialog="closeUpdateAddressDialog"></UpdateAddress>
                    </q-dialog>
                    <q-dialog persistent position="right" v-model="editEmailDialog">
                        <EditEmail @closeEditEmailDialog="closeEditEmailDialog"
                            @closeEditEmailCancelDialog="editEmailDialog = false"></EditEmail>
                    </q-dialog>
                    <q-dialog persistent position="right" v-model="verifyEmailDialog">
                        <VerifyEmail @closeVerifyEmailDialog="closeVerifyEmailDialog" :verificationId="verificationId">
                        </VerifyEmail>
                    </q-dialog>
                    <q-dialog v-model="paymentCancelAlert" :style="'height: 400px;'">
                        <q-card>
                            <q-card-section>
                            <div class="text-h6 text-red text-bold text-center">Payment Cancelled</div>
                            </q-card-section>
                            <q-card-section class="q-pt-none text-center mx-4">
                                <!-- Order failed due to payment has been cancelled. -->
                                Your payment has been cancelled, If amount has been deducted from you will be refunded back
                            </q-card-section>
                            <q-card-actions align="center">
                            <q-btn flat label="Close" color="primary" v-close-popup @click="paymentCancelAlert = false" />
                            </q-card-actions>
                        </q-card>
                        </q-dialog>
                </div>
                <!-- <div class="col-2">
                </div> -->
            </div>
        </div>
    </div>
</template>
  
<script>
import axios from 'axios';
import _ from 'lodash';
import Constants from '../../Constants/Constant';
import { NetworkCommunicator, setHeader } from "../../plugins/NetworkResourceHandler";
import UpdateAddress from './UpdateAddress.vue'
import EditEmail from './EditEmail.vue'
import VerifyEmail from './VerifyEmail.vue'


export default {
    name: 'PlaceOrder',
    components: { UpdateAddress, EditEmail, VerifyEmail },

    data: function () {
        return {
            cartProducts: [],
            verificationId: '',
            organizationUserState: "",
            sgstAmount: 0,
            cgstAmount: 0,
            igstAmount: 0,
            organizationEmailStatus: false,
            addPartnerDialog: false,
            editEmailDialog: false,
            paymentCancelAlert: false,
            verifyEmailDialog: false,
            productsUpdatedData: [],
            cartData: [],
            allProducts: [],
            payableTotal: 0,
            savingTotal: 0,
            isHovered: false,
            savingPercentage: 0,
            user: JSON.parse(localStorage.getItem('user')),
            isLoading: false,
            page: 1,
            hasMoreData: true,
            createdmap: {
                success: 'success',
                created: 'Failed'
            }
        }
    },

    async created() {
        this.organizationUserState = this.user?.organization?.address?.state?.toLowerCase();
        this.orgEmailStatus();
        setHeader();
        const apiUrl = Constants.api_url + 'getCurrentStock';
        // const request = {
        //     offset: (this.page - 1) * this.limit,
        //     limit: this.limit,
        // }
        const response = await NetworkCommunicator('GET', apiUrl);
        if (response) {
            this.allProducts = response.data;
        }
        const savedCart = localStorage.getItem('cartProducts');
        if (savedCart) {
            this.cartData = JSON.parse(savedCart);
        }
        this.calculateCartTotal((savedCart ? JSON.parse(savedCart) : []));
        this.loadData();
    },

    computed: {
        gstColumn () {
        if(this.organizationUserState == 'gujarat') {
            return true;
        } else {
            return false;
        }
        }
    },

    watch: {
        cartProducts: {
            handler(newVal) {
                this.cartProducts = newVal;
            }
        },
    },

    methods: {
        gstCount(type) {
            if(type == 'sgst' || type == 'cgst') {
                const count = (this.payableTotal * 9) / 100;
                this.sgstAmount = count;
                this.cgstAmount = count;
                return count;
            } else {
                const igstCount = (this.payableTotal * 18) / 100;
                this.igstAmount = igstCount;
                return igstCount;
            }
        },

        roundedAmount() {
            const difference = (this.payableAmount() - this.payableTotalAmount()).toFixed(2);
            const value = Math.abs(difference);
            return value;
        },

        sign() {
            const value = (this.payableAmount() - this.payableTotalAmount()).toFixed(2);
            if (value >= 0) {
                return '+';
            } else {
                return '-';
            }
        },

        payableTotalAmount() {
            if (this.organizationUserState == 'gujarat') {
                const sum = this.payableTotal + this.sgstAmount + this.cgstAmount;
                return sum;
            } else {
                const sum = this.payableTotal + this.igstAmount;
                return sum; 
            }
        },

        payableAmount() {
            if (this.organizationUserState == 'gujarat') {
                const sum = this.payableTotal + this.sgstAmount + this.cgstAmount;
                const value = this.roundedValue(sum);
                return value;
            } else {
                const sum = this.payableTotal + this.igstAmount;
                const value = this.roundedValue(sum);
                return value; 
            }
        },

        roundedValue(value) {
            if (value % 1 >= 0.5) {
                return Math.ceil(value);
            } else {
                return Math.floor(value);
            }
        },

        closeEditEmailDialog() {
            this.editEmailDialog = false;
            this.retriveUserData();
            this.$nextTick(() => {
                this.verifyEmail();
            });
        },

        closeUpdateAddressDialog() {
            this.addPartnerDialog = false;
            this.retriveUserData();
        },

        closeVerifyEmailDialog() {
            this.verifyEmailDialog = false;
            this.retriveUserData();
            this.orgEmailStatus();
        },

        retriveUserData() {
            this.user = JSON.parse(localStorage.getItem('user'))
        },

        async orgEmailStatus() {
            const apiUrl = Constants.api_url + 'checkOrgEmailStatus';
            try {
                const request = {
                    orgId: this.user.organization.id
                }
                const response = await axios.post(apiUrl, request);
                if (response && response.data) {
                    this.organizationEmailStatus = response.data.data;
                    this.isLoading = true
                }
            } catch (error) {
                this.isLoading = true
                console.error("Error in checking Email status", error);
            }
        },

        UpdateAddressData() {
            this.addPartnerDialog = true
        },

        editEmail() {
            this.editEmailDialog = true
        },

        async verifyEmail() {
            const apiUrl = Constants.api_url + 'sendOTPVerifyEmail';
            try {
                const request = {
                    orgId: this.user.organization.id,
                    userId: this.user.id,
                    email: this.user.organization.email
                }
                const response = await axios.post(apiUrl, request);
                if (response && response.data) {
                    this.verificationId = response.data.data.id;
                    this.verifyEmailDialog = true
                }
            } catch (error) {
                console.error("Error in Sending OTP to Email", error);
            }
        },

        payNow() {
            if (this.organizationEmailStatus == false) {
                this.$q.notify({
                    position: 'top-right',
                    message: 'Please Verify Your Email First!'
                });
            } else {
                this.payPaymentNow();
            }
        },

        async payPaymentNow() {
            const sumOfQuantities = this.cartProducts.reduce((total, item) => total + item.quantity, 0);
            const finalAmount = this.payableAmount();
            const simplifiedItems = this.cartProducts.map(item => {
                return {
                    productId: item.id,
                    qty: item.quantity,
                    sku: item.sku,
                    rate: Number(item.mrp),
                    amount: Number(this.getPriceData(item))
                }
            });

            const data = {
                "orgId": this.user.orgId,
                "partnerId": this.user.id,
                "orderItemsCount": this.cartProducts.length,
                "orderAmount": this.payableTotal,
                "sgstRate":  this.gstColumn ? 9 : 0,
                "cgstRate": this.gstColumn ? 9 : 0,
                "igstRate": this.gstColumn ? 0 : 18,
                "finalAmount": finalAmount,
                "sgstAmount": this.gstColumn ? this.sgstAmount : 0,
                "cgstAmount": this.gstColumn ? this.cgstAmount : 0,
                "igstAmount": this.gstColumn ? 0 : this.igstAmount,
                "totalQty": sumOfQuantities,
                "orderItems": simplifiedItems
            }

            this.$q.dialog({
                title: 'Payment',
                message: 'Are you Sure, you want to pay now?',
                cancel: true,
                persistent: true,
            }).onOk(async () => {
                const apiUrl = Constants.api_url + 'addOnlineOrder';
                try {
                    const response = await axios.post(apiUrl, data);
                    if (response && response.data) {
                        this.openRazorpayCheckout(response.data);
                    }
                } catch (error) {
                    console.error("Error in API call:", error);
                }
            })
        },

        async openRazorpayCheckout(data) {
            try {
                const orderNumber = data.data.orderNumber;
                const orderId = data.data.id;
                const finalAmount = this.payableAmount();
                const razorpayOptions = {
                    key: Constants.razorPayKey,
                    amount: Number(finalAmount) * 100,
                    currency: 'INR',
                    name: 'AIPL',
                    notes: {
                        orderID: orderId
                    },
                    handler: (response) => {
                        if (response && response.razorpay_payment_id) {
                            localStorage.setItem('cartProducts', []);
                            this.$router.push(`/Partners/Stock/OrderSummary?orderId=${orderNumber}`);
                        } else {
                            this.$router.push(`/Partners/Stock/TransactionFailed`);
                        }
                    },
                    modal: {
                        ondismiss: () => {
                            this.handleDismiss(orderId);
                            // await axios.post(apiUrl, data);
                            // this.$q.notify(`Payment cancelled!`);
                        }
                    },
                    notes: {
                        orderID: orderId
                    },
                };
                const razorpayInstance = new Razorpay(razorpayOptions);
                razorpayInstance.open();
            } catch (error) {
                this.$router.push(`/Partners/Stock/TransactionFailed`);
                console.error('Error initiating Razorpay payment:', error);
            }
        },

        async handleDismiss(orderId) {
            const apiUrl = Constants.api_url + 'order/status/update';
            const data = {
                orderId: orderId,
                status: 'failed',
            }
            await axios.post(apiUrl, data);
            // this.$q.notify({
            //     position: 'center',
            //     message: 'Order failed due to Payment cancelled!'
            // });
            this.paymentCancelAlert = true;
        },

        removeProduct(id) {
            this.$q.dialog({
                title: 'Remove',
                message: 'Are you Sure, you want to Remove?',
                cancel: true,
                persistent: true,
            }).onOk(() => {
                const newArray = this.cartProducts.filter(item => item.id !== id);
                this.cartProducts = newArray;
                this.calculateCartTotal(newArray);
                localStorage.setItem('cartProducts', JSON.stringify(newArray));
                this.$q.notify({
                    position: 'top-right',
                    message: 'Product removed from the cart successfully!'
                });
            })
        },

        handleInput(product, event) {
            const inputedValue = event.target.value;
            let quantity = parseInt((product.quantity ? product.quantity : 1), 10);
            quantity = Math.min(Math.max(quantity, 1), product.maxPurchaseLimit);
            product.quantity = quantity;
            if (inputedValue > product.maxPurchaseLimit) {
                this.$q.notify({
                    position: 'top-right',
                    message: `You can buy maximum ${product.maxPurchaseLimit} quantities. Only ${product.maxPurchaseLimit} items left.`
                });
            }
            if (inputedValue == 0) {
                this.$q.notify({
                    position: 'top-right',
                    message: 'You have to buy minimum 1 quantity or you can remove product from the cart.'
                });
            }

            const updatedProducts = this.cartProducts.map(item => {
                if (item.id === product.id) {
                    return { ...item, quantity: quantity };
                }
                return item;
            });
            this.cartProducts = updatedProducts;
            this.calculateCartTotal(updatedProducts);
            localStorage.setItem('cartProducts', JSON.stringify(updatedProducts));
        },

        calculateCartTotal(products) {
            const totalAmount = products.reduce((total, product) => {
                return total + this.calculateProductTotal(product);
            }, 0);
            this.payableTotal = totalAmount;

            const totalSavingAmount = products.reduce((total, product) => {
                return total + this.calculateProductSavingTotal(product);
            }, 0);
            this.savingTotal = totalSavingAmount;

            const savingPercentage = ((100 * Number(this.savingTotal)) / (Number(this.payableTotal) + Number(this.savingTotal)));
            this.savingPercentage = isNaN(savingPercentage) ? 0 : savingPercentage.toFixed(0);
        },

        calculateProductTotal(product) {
            const pricing = product.pricing.find(
                (price) => product.quantity >= price.qtyFrom && product.quantity <= price.qtyUpTo
            );

            if (pricing) {
                return Number(product.quantity) * Number(pricing.price);
            } else {
                const lowestPrice = product.pricing.reduce((minPrice, currentPrice) => {
                    const price = parseInt(currentPrice.price);
                    return price < minPrice ? price : minPrice;
                }, Infinity);
                const priceData = Number(lowestPrice) * Number(product.quantity);
                return priceData;
            }
        },

        calculateProductSavingTotal(product) {
            const savingTotal = (Number(product.mrp) * Number(product.quantity)) - (this.calculateProductTotal(product));
            return savingTotal;
        },

        imageUrl(image) {
            const url = Constants.base_url + image;
            return url;
        },

        openOrderDetail(product) {
            this.$router.push(`/Partners/Stock/ProductDetails/?productId=${product.id}`);
        },

        disableIncrementButton(product) {
            if (Number(product.quantity) >= Number(product.maxPurchaseLimit)) {
                return true;
            }
            return false;
        },

        decreaseQuantity(product) {
            if (Number(product.quantity)) {
                const updatedQuantity = Number(product.quantity) - 1
                const updatedProducts = this.cartProducts.map(item => {
                    if (item.id === product.id) {
                        return { ...item, quantity: updatedQuantity };
                    }
                    return item;
                });
                this.cartProducts = updatedProducts;
                this.calculateCartTotal(updatedProducts);
                localStorage.setItem('cartProducts', JSON.stringify(updatedProducts));
            }
        },

        increaseQuantity(product) {
            let updatedQuantity = 0;
            if (Number(product.quantity)) {
                updatedQuantity = Number(product.quantity) + 1;
            } else {
                updatedQuantity = 1;
            }

            const updatedProducts = this.cartProducts.map(item => {
                if (item.id === product.id) {
                    return { ...item, quantity: updatedQuantity };
                }
                return item;
            });
            this.cartProducts = updatedProducts;
            this.calculateCartTotal(updatedProducts);
            localStorage.setItem('cartProducts', JSON.stringify(updatedProducts));
        },

        getPriceData(product) {
            try {
                const pricingObject = product.pricing.find(pricing => {
                    const qtyFrom = parseInt(pricing.qtyFrom);
                    const qtyUpTo = parseInt(pricing.qtyUpTo);
                    return product.quantity >= qtyFrom && product.quantity <= qtyUpTo;
                });

                if (pricingObject) {
                    return pricingObject.price;
                } else {
                    const lowestPrice = product.pricing.reduce((minPrice, currentPrice) => {
                        const price = parseInt(currentPrice.price);
                        return price < minPrice ? price : minPrice;
                    }, Infinity)
                    return lowestPrice;
                }
            } catch (error) {
                console.error('Error fetching online products data', error);
            }
        },

        getPercentageData(product) {
            const price = this.getPriceData(product)
            const result = 100 - ((price * 100) / product.mrp);
            return result.toFixed(0);
        },

        loadData() {
            const savedCart = localStorage.getItem('cartProducts');
            this.cartProducts = savedCart ? JSON.parse(savedCart) : [];

            for (const cartProduct of this.cartProducts) {
                const correspondingItem = this.allProducts.find((item) => item.id == cartProduct.id);
                if (correspondingItem) {
                    cartProduct.stock = correspondingItem.stock;
                    cartProduct.maxPurchaseLimit = correspondingItem.maxPurchaseLimit;
                }
            }
        }
    }
}

</script>
  
<style scoped>
.square {
    border: 1px solid #000;
    padding: 6px 12px 6px 12px;
    display: inline-block;
    background-color: white;
}

.icon-img-set {
    margin: 0 8px 0 22px;
}

.icon_hover {
    height: 38px;
    width: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin-left: 50px;
}

.icon_hover:hover {
    background-color: #EBEBEB;
}

.text-price-value {
    color: #167E85;
}

.font-family {
    font-family: avenirRegular;
}

.font-text-size {
  font-size: 14px;
}

.pd-btn {
    width: 100%;
}

@media only screen and (max-width: 1100px) {
    .main-container {
        max-width: 980px;
        margin: 0 auto;
    }

    .view-cart {
        height: 50px;
    }
}

@media only screen and (min-width: 1101px) and (max-width: 1280px) {
    .main-container {
        max-width: 1024px;
        margin: 0 auto;
    }

    .view-cart {
        height: 50px;
    }
}

@media only screen and (min-width: 1281px) and (max-width: 1780px) {
    .main-container {
        max-width: 1240px;
        margin: 0 auto;
    }

    .view-cart {
        height: 50px;
    }
}

@media only screen and (min-width: 1781px) {
    .main-container {
        max-width: 1440px;
        margin: 0 auto;
    }

    .view-cart {
        height: 50px;
    }
}

.order-summary-grid{
position: sticky;
  top: 0;
  z-index: 1;
  box-shadow: none;
  border-radius: 15px;
}

</style>